<template>
  <div>
    <section class="content-header">
      <h1>
        <span>{{$ml.get('shared.annualPermitGroups')}}</span>
      </h1>
      <ol class="breadcrumb">
        <li>
          <i class="fa fa-dashboard"></i>
          <span>{{$ml.get('shared.dashboard')}}</span>
        </li>
        <li>
          <i class="fa fa-book"></i>
          <span>{{$ml.get('shared.definitions')}}</span>
        </li>
        <li>
          <span>{{$ml.get('shared.annualPermitGroups')}}</span>
        </li>
      </ol>
    </section>
    <section class="content">
      <div class="row">
        <div class="col-sm-4">
          <div class="box box-primary">
            <div class="box-header">
              <h3 class="box-title">
                <span>{{$ml.get('annualPermitGroups.annualPermitGroupList')}}</span>
              </h3>
              <div class="box-tools pull-right"></div>
            </div>
            <div class="box-body">
              <div
                v-show="annualPermitList.length > 0"
                class="table-responsive no-padding"
                :style="windowHeightSize"
              >
                <table class="table table-hover">
                  <tbody>
                    <tr v-for="annualPermit in annualPermitList" :key="annualPermit.id">
                      <td>
                        <span>{{annualPermit.name}}</span>
                      </td>
                      <td>
                        <button
                          class="btn btn-primary btn-sm"
                          @click="getAPDetail(annualPermit.id)"
                        >
                          <i class="fa fa-search"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div v-show="annualPermitList.length == 0" class="callout callout-info">
                <i class="fa fa-info-circle"></i> {{$ml.get('annualPermitGroups.annualPermitGroupNotRecord')}}
              </div>
            </div>
            <div class="overlay" id="load" :hidden="!isLoading">
              <i class="fa fa-refresh fa-spin"></i>
            </div>
          </div>
        </div>
        <div class="col-sm-8">
          <div class="box box-primary">
            <div class="box-header with-border">
              <h3 class="box-title">
                <span>{{$ml.get('annualPermitGroups.annualPermitGroupInfo')}}</span>
              </h3>
              <div class="box-tools pull-right">
                <button
                  v-show="authControl == 0"
                  @click="newAnnualPermit()"
                  type="button"
                  class="btn btn-sm btn-warning "
                >{{$ml.get('annualPermitGroups.annualPermitGroupInfo')}}</button>
              </div>
            </div>
            <div class="box-body" align="center">
              <div class="row" style="margin-top:10px;">
                <div class="col-sm-3">
                  <h5>
                    <span>{{$ml.get('annualPermitGroups.groupName')}}</span> :
                  </h5>
                </div>
                <div class="col-sm-9">
                  <input type="text" class="form-control" v-model="annualPermit.name" />
                </div>
              </div>
              <hr />
              <div class="row" style="margin-top:10px;">
                <div class="form-group col-sm-3">
                  <label>{{$ml.get('annualPermitGroups.start')}}</label>
                  <input type="number" class="form-control text-center" min="0" v-model="start" />
                </div>
                <div class="form-group col-sm-3">
                  <label>{{$ml.get('annualPermitGroups.end')}}</label>
                  <input type="number" class="form-control text-center" min="0" v-model="end" />
                </div>
                <div class="form-group col-sm-3">
                  <label>{{$ml.get('annualPermitGroups.deservedDay')}}</label>
                  <input type="number" class="form-control text-center" min="0" v-model="claim" />
                </div>
                <div class="col-sm-3">
                  <button
                    @click="addAPDefinition()"
                    type="button"
                    class="btn btn-primary "
                    style="width:100%; margin-top:25px;"
                  >
                    <i class="fa fa-plus"></i> {{$ml.get('general.add')}}
                  </button>
                </div>
              </div>
              <hr />
              <div class="row" style="margin-top:10px;">
                <div class="col-sm-12">
                  <div
                    v-show="aPDefinitionList.length > 0"
                    class="table-responsive no-padding"
                    style="max-height:350px; owerflow:auto;"
                  >
                    <table class="table table-hover text-center">
                      <thead>
                        <th>{{$ml.get('annualPermitGroups.start')}}</th>
                        <th>{{$ml.get('annualPermitGroups.end')}}</th>
                        <th>{{$ml.get('annualPermitGroups.deservedDay')}}</th>
                        <th style="width:20px"></th>
                      </thead>
                      <tbody>
                        <tr v-for="(aPDefinition, index) in aPDefinitionList" :key="index">
                          <td>
                            <span>{{aPDefinition.start}}</span>
                          </td>
                          <td>
                            <span>{{aPDefinition.end}}</span>
                          </td>
                          <td>
                            <span>{{aPDefinition.claim}}</span>
                          </td>
                          <td>
                            <button
                              class="btn btn-danger btn-sm"
                              @click="deleteAPDefinition(index)"
                            >
                              <i class="fa fa-remove"></i>
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div v-show="aPDefinitionList.length == 0" class="callout callout-info">
                    <i class="fa fa-info-circle"></i> {{$ml.get('annualPermitGroups.annualPermitGroupDetailNotRecord')}}
                  </div>
                </div>
              </div>
            </div>
            <div class="overlay" id="load" :hidden="!isLoadingDetail">
              <i class="fa fa-refresh fa-spin"></i>
            </div>
            <div class="box-footer">
              <div class="pull-right">
                <button
                  v-show="!isNewAnnualPermit && authControl == 0"
                  type="button"
                  data-toggle="modal"
                  data-target="#modal-sil"
                  class="btn btn-sm btn-danger "
                  style="margin: 5px; width:120px;"
                >{{$ml.get('general.delete')}}</button>
                <button
                  v-show="isNewAnnualPermit && authControl == 0"
                  type="button"
                  data-toggle="modal"
                  data-target="#modal-kaydet"
                  class="btn btn-sm btn-success "
                  style="margin: 5px; width:120px;"
                >{{$ml.get('general.save')}}</button>
                <button
                  v-show="!isNewAnnualPermit && authControl == 0"
                  type="button"
                  data-toggle="modal"
                  data-target="#modal-guncelle"
                  class="btn btn-sm btn-success "
                  style="margin: 5px; width:120px;"
                >{{$ml.get('general.update')}}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /.MODAL START-->
      <div class="modal modal-info fade" id="modal-guncelle">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>{{$ml.get('general.update')}}</span>
              </h4>
            </div>
            <div class="modal-body">
              <div>
                <span>{{this.annualPermit.name}}</span>
              </div>
              <br />
              <p></p>
              <span>{{$ml.get('annualPermitGroups.isContinueAnnualPermitGroupUpdate')}}</span>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-danger" data-dismiss="modal">
                <i class="fa fa-remove"></i>
                <span>{{$ml.get('general.cancel')}}</span>
              </button>
              <button @click="saveAnnualPermit()" class="btn btn-info" data-dismiss="modal">
                <i class="fa fa-refresh"></i>
                <span>{{$ml.get('general.update')}}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- /.MODAL END -->
      <!-- /.MODAL START-->
      <div class="modal modal-success fade" id="modal-kaydet">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>{{$ml.get('general.save')}}</span>
              </h4>
            </div>
            <div class="modal-body">
              <p>{{this.annualPermit.name}}</p>
              <span>{{$ml.get('annualPermitGroups.isContinueAnnualPermitGroupSave')}}</span>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-danger" data-dismiss="modal">
                <i class="fa fa-remove"></i>
                <span>{{$ml.get('general.cancel')}}</span>
              </button>
              <button @click="saveAnnualPermit()" class="btn btn-success" data-dismiss="modal">
                <i class="fa fa-check"></i>
                <span>{{$ml.get('general.save')}}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- /.MODAL END -->
      <!-- /.MODAL START-->
      <div class="modal modal-danger fade" id="modal-sil">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 class="modal-title">
                <span>{{$ml.get('general.delete')}}</span>
              </h4>
            </div>
            <div class="modal-body">
              <div>
                <span>{{this.annualPermit.name}}</span>
              </div>
              <br />
              <p></p>
              <span>{{$ml.get('annualPermitGroups.isContinueAnnualPermitGroupDelete')}}</span>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-danger" data-dismiss="modal">
                <i class="fa fa-remove"></i>
                <span>{{$ml.get('general.cancel')}}</span>
              </button>
              <button @click="deleteAnnualPermit()" class="btn btn-danger" data-dismiss="modal">
                <i class="fa fa-trash"></i>
                <span>{{$ml.get('general.delete')}}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- /.MODAL END -->
    </section>
  </div>
</template>
<script>
export default {
  data() {
    return {
      windowHeight: window.innerHeight,
      isLoading: false,
      isLoadingDetail: false,
      isNewAnnualPermit: true,
      annualPermits: [],
      start: 0,
      end: 0,
      claim: 0,
      annualPermit: {
        id: null,
        name: "",
        definitions: []
      }
    };
  },
  computed: {
    authControl(){
      return this.$store.getters.getAuthTanimlamalar;
    },
    annualPermitList() {
      return this.annualPermits;
    },
    aPDefinitionList() {
      return this.annualPermit.definitions;
    },
  windowHeightSize() {
      if (this.windowHeight) {
        let height = this.windowHeight - 260;
        return "max-height:" + height + "px;overflow:auto;";
      } else {
        return "max-height:370px;overflow:auto;";
      }
    }
  },
  watch: {
    windowHeight(newHeight, oldHeight) {
      if (newHeight < 576) {
        //MOBİL
      } else {
        //WEB
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
  },
  methods: {
    onResize() {
      this.windowHeight = window.innerHeight;
    },
    deleteAPDefinition(index) {
      this.annualPermit.definitions.splice(index, 1);
    },
    addAPDefinition() {
      if($.isNumeric(this.start) == false || $.isNumeric(this.end) == false || $.isNumeric(this.claim) == false){
        alertify.warning(this.$ml.get('alerts.pleaseCheckEnteredValue'));
        return;
      } else if (this.start == 0 || this.end == 0 || this.claim == 0) {
        alertify.warning(this.$ml.get('alerts.pleaseCheckEnteredValue'));
        return;
      } else {
        this.annualPermit.definitions.push({
          id: null,
          start: this.start,
          end: this.end,
          claim: this.claim
        });
      }
    },
    newAnnualPermit() {
      this.isNewAnnualPermit = true;
      this.start = 0;
      this.end = 0;
      this.claim = 0;
      this.annualPermit = { id: null, name: "", definitions: [] };
    },
    async deleteAnnualPermit() {
      try {
        this.isLoadingDetail = true;
        let id = this.annualPermit.id;
        const response = await this.$axios
          .delete("/AnnualPermit/" + id)
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get('errors.connectionError'));
                this.isLoadingDetail = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoadingDetail = false;
                return;
              }
            }
          });
        this.getAnnualPermits();
        this.newAnnualPermit();
        alertify.success(this.$ml.get('alerts.deletedSuccessfully'));
        this.isLoadingDetail = false;
      } catch (error) {
        alertify.error("Hata Oluştu : " + error);
        this.isLoadingDetail = false;
      }
    },
    async saveAnnualPermit() {
      if (this.annualPermit.name == "") {
        alertify.warning(this.$ml.get('alerts.pleaseEnterAName'));
        return;
      }
      this.isLoadingDetail = true;
      if (this.isNewAnnualPermit) {
        try {
          let annualPermit2 = this.annualPermit;
          const response = await this.$axios
            .post("/AnnualPermit", {
              name: annualPermit2.name,
              definitions: annualPermit2.definitions
            })
            .catch(error => {
              if (error.response) {
                if (error.response.status == 401) {
                  this.$store.dispatch("logout");
                }
              } else {
                if (
                  error.message == "Network Error" ||
                  error.message == "Error: Network Error"
                ) {
                  alertify.error(this.$ml.get('errors.connectionError'));
                  this.isLoading = false;
                  return;
                } else {
                  console.error(error);
                  alertify.error(error.message);
                  this.isLoading = false;
                  return;
                }
              }
            });
          if (response.status == 200) {
            alertify.success(this.$ml.get('alerts.savedSuccessfully'));
          } else {
            alertify.error(response.message);
          }
          this.getAnnualPermits();
          this.newAnnualPermit();
          this.isLoadingDetail = false;
        } catch (error) {
          console.error(error);
          alertify.error(error.message);
          this.isLoadingDetail = false;
        }
      } else {
        //GÜNCELLE
        try {
          let annualPermit2 = this.annualPermit;
          const response = await this.$axios
            .post("/AnnualPermit/" + annualPermit2.id, {
              name: annualPermit2.name,
              definitions: annualPermit2.definitions
            })
            .catch(error => {
              if (error.response) {
                if (error.response.status == 401) {
                  this.$store.dispatch("logout");
                }
              } else {
                if (
                  error.message == "Network Error" ||
                  error.message == "Error: Network Error"
                ) {
                  alertify.error(this.$ml.get('errors.connectionError'));
                  this.isLoading = false;
                  return;
                } else {
                  console.error(error);
                  alertify.error(error.message);
                  this.isLoading = false;
                  return;
                }
              }
            });
          if (response.status == 200) {
            alertify.success(this.$ml.get('alerts.updatedSuccessfully'));
          } else {
            alertify.error(response.message);
          }
          this.getAnnualPermits();
          this.isLoadingDetail = false;
        } catch (error) {
          console.error(error);
          alertify.error(error);
          this.isLoadingDetail = false;
        }
      }
    },
    async getAPDetail(id) {
      try {
        this.isLoadingDetail = true;
        this.start = 0;
        this.end = 0;
        this.claim = 0;
        const response = await this.$axios
          .get("/AnnualPermit/" + id)
          .then(response => {
            this.isNewAnnualPermit = false;
            this.annualPermit.id = id;
            this.annualPermit.name = response.data.name;
            this.annualPermit.definitions = response.data.definitions;
            this.isLoadingDetail = false;
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get('errors.connectionError'));
                this.isLoadingDetail = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoadingDetail = false;
                return;
              }
            }
          });
      } catch (error) {
        console.error(error);
        alertify.error(error);
        this.isLoadingDetail = false;
      }
    },
    async getAnnualPermits() {
      try {
        this.isLoading = true;
        const annualPermits = [];
        const response = await this.$axios
          .get("/AnnualPermit")
          .then(response => {
            response.data.forEach(doc => {
              annualPermits.push({
                id: doc.id,
                name: doc.name
              });
            });
            this.annualPermits = annualPermits;
            this.isLoading = false;
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get('errors.connectionError'));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası :" + error.message);
        this.isLoading = false;
      }
    },
    async getAuthControl() {
      if (this.authControl == 1) {
        alertify.warning(
          this.$ml.get('alerts.youAreOnlyAuthorizedToViewThisPage')
        );
      }
    }
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  async created() {
    await this.getAuthControl();
    await this.getAnnualPermits();
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/annualPermits/AnnualPermits.vue